import FormValidationContainer from "../../../../components/formsAndTable/forms/formControls/formValidation";

const FormValidation = () => {
  return <FormValidationContainer />;
};

export default FormValidation;
